import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import useAuthRequest from '../../../services/requests.service.js';
import { Segmented, Tabs } from 'antd';
import InformationView from './InformationView.js';
import PlansSub from './PlansSub.js';

const items = [
  {
    key: '1',
    label: 'Vue générale',
  },
  {
    key: '2',
    label: 'Mes abonnements',
  },
];

const SettingsSub = ({ page, setPage }) => {


  const { id } = useParams();
  const request = useAuthRequest();
  const [value, setValue] = useState('1');
  const [subscriptions, setSubscriptions] = useState([]);
  const [invoices, setInvoices] = useState([])
  const [invoice, setInvoice] = useState(null)
  const [stripeProducts, setStripeProducts] = useState(null);

  const [isLoading, setIsLoading] = useState(false)


  useEffect(() => {
    if(page?.customerId){
      getStripeInvoices()
      getStripeNextInvoice();
      getStripeSubscriptions();
      getStripeProducts();
    }
  }, [page?.customerId])
  




  const onChange = (key) => {
    setValue(key)
  };

  const onTabClick = (key) => {
    if (key === '1' && page?.customerId) {
      getStripeInvoices()
      getStripeNextInvoice()
      getStripeSubscriptions()
      getStripeProducts()
    }
  };

  const getStripeProducts= async () => {
    let res = await request.getDataAPI('/stripe/products')
    setStripeProducts(res?.products)
  }

  const getStripeSubscriptions = async () => {
    setIsLoading(true)

    let res = await request.getDataAPI('/stripe/subscriptions/' + page.customerId);
    setSubscriptions(res?.subscriptions)
    setIsLoading(false)

  }

  const getStripeInvoices = async () => {
    setIsLoading(true)

    let res = await request.getDataAPI('/stripe/invoices/' + page.customerId);
    setInvoices(res?.invoices)
    setIsLoading(false)

  }

  const getStripeNextInvoice= async () => {
    setIsLoading(true)

    try{
      let res = await request.getDataAPI('/stripe/upcominginvoice/' + page.customerId);
      setInvoice(res?.upcomingInvoice)

    }catch(e){
      setInvoice(null)

    }
    setIsLoading(false)

  }

  return (
    <div className='h-full m-4 md:w-full '>
      <Tabs activeKey={value} type="card" items={items} onChange={onChange} onTabClick={onTabClick} />
      {
        value === '1' && <InformationView  isLoading={isLoading} page={page} subscriptions={subscriptions} invoice={invoice} invoices={invoices} stripeProducts={stripeProducts} onGoToPlans={() => setValue('2')}/>
      }
      {
        value === '2' && <PlansSub page={page}/>
      }
    </div>
  )
}

export default SettingsSub